import React from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { getUser } from '@/store/getters'

export const Scripts = ( props ) => {
  if( process.env.NODE_ENV === 'development' ) return null
  const { user : { user } } = props

  return (
    <Helmet>

      {/* Script Hotjar */}
      {/*<script>*/}
      {/*  {`*/}
      {/*    (function(h,o,t,j,a,r){*/}
      {/*      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};*/}
      {/*      h._hjSettings={hjid:1035500,hjsv:6};*/}
      {/*      a=o.getElementsByTagName('head')[0];*/}
      {/*      r=o.createElement('script');r.async=1;*/}
      {/*      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;*/}
      {/*      a.appendChild(r);*/}
      {/*    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');*/}
      {/*  `}*/}
      {/*</script>*/}

      {/* Script Clarity */}
      <script>
        {`
          (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "56vjaxb7rd");
        `}
      </script>

      {/* Script capture BA Intelligence */}
      <script>
        {`
          const clientEmail = '${user.email}'
          const groupTag = 6
        `}
      </script>
      <script src="https://intelligence.builderall.com/dist/capture-min.js"></script>
    </Helmet>
  )
}

const mapStateToProps = ( state ) => {
  const user = getUser( state )
  return { user }
}

export default connect( mapStateToProps )( Scripts )



// WEBPACK FOOTER //
// ./src/components/Scripts.js